import { render, staticRenderFns } from "./UpdateCurriculam.vue?vue&type=template&id=0f523353&scoped=true"
import script from "./UpdateCurriculam.vue?vue&type=script&lang=js"
export * from "./UpdateCurriculam.vue?vue&type=script&lang=js"
import style0 from "./UpdateCurriculam.vue?vue&type=style&index=0&id=0f523353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f523353",
  null
  
)

export default component.exports